import type { EventBus } from "../core/EventBus.ts";
import type { Enemy } from "../entities/Enemy.ts";
import type { VirusSynergyMods } from "../entities/types.ts";
import type { VirusProfile } from "./VirusLevels.ts";
import { infectEnemiesInRadius } from "./VirusInfect.ts";

export interface HazardPoolZone {
  x: number;
  y: number;
  profile: VirusProfile;
  remaining: number;
  tickTimer: number;
}

export function makeHazardPool(
  x: number,
  y: number,
  p: VirusProfile,
): HazardPoolZone {
  return {
    x,
    y,
    profile: p,
    remaining: p.hazardPoolDuration,
    tickTimer: p.tickInterval,
  };
}

/** Advance all pools: decay lifetime, apply periodic re-infect, remove expired. */
export function updateHazardPools(
  pools: HazardPoolZone[],
  enemies: Enemy[],
  dt: number,
  ctx: { bus: EventBus; virusMods?: VirusSynergyMods | null },
): void {
  for (let i = pools.length - 1; i >= 0; i--) {
    const pool = pools[i]!;
    pool.remaining -= dt;
    pool.tickTimer -= dt;

    if (pool.tickTimer <= 0) {
      infectEnemiesInRadius(
        pool.x,
        pool.y,
        pool.profile,
        enemies,
        ctx.virusMods,
      );
      pool.tickTimer += pool.profile.tickInterval;
      ctx.bus.emit("virus.hazard.tick", {
        x: pool.x,
        y: pool.y,
        radius: pool.profile.zoneRadius,
      });
    }

    if (pool.remaining <= 0) {
      pools[i] = pools[pools.length - 1]!;
      pools.pop();
    }
  }
}
